import { isRouteErrorResponse, useRouteError } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/Button'
import { ErrorState } from '@/components/ui/ErrorState'
import { ApiError } from '@/lib/api/problem'

export function RouteError() {
  const { t } = useTranslation()
  const error = useRouteError()

  const normalised = isRouteErrorResponse(error)
    ? new ApiError(error.status, { status: error.status, title: error.statusText }, null)
    : error

  return (
    <div className="stage min-h-dvh">
      <div className="rise-in mx-auto flex max-w-xl flex-col gap-4 p-6 pt-16">
        <ErrorState error={normalised} />
        <div className="flex justify-center">
          <Button
            variant="secondary"
            icon="refresh"
            onClick={() => {
              window.location.reload()
            }}
          >
            {t('errors.reload')}
          </Button>
        </div>
      </div>
    </div>
  )
}
